import React from 'react';
import { Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RaaRoles } from '../../../utility/SecurityRules';
import HasRolePrivileges from '../../highorder/HasRolePrivileges';
import { selectSessionInformation } from '../../../redux/slices/sessionSlice';
import ChecklistCompletionBadge from '../../setup/ChecklistCompletionBadge';

function SubscriptionNavTabs({ activeKey }) {
  const history = useHistory();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const hasLapsedAccount = !activeSubscription || activeSubscription.subscriptionTierLevel <= 0;

  const tabLinkClass = 'text-dark text-decoration-none';

  const goTo = (path) => (event) => {
    event.preventDefault();
    history.push(path);
  };

  const disabledTabProps = hasLapsedAccount
    ? {
      disabled: true,
      tabIndex: -1,
      'aria-disabled': true,
      onClick: (event) => event.preventDefault(),
    }
    : {};

  return (
    <>
      <div className="clearfix text-right mb-3">
        <h4 className="float-left">Manage Account</h4>
      </div>

      <Nav
        variant="tabs"
        className="mb-3"
        defaultActiveKey="/s/subscription/billing"
        activeKey={activeKey}
      >
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.BILLING]}
        >
          <Nav.Item>
            <Nav.Link
              href="/s/subscription/billing"
              eventKey="/s/subscription/billing"
              onClick={goTo('/s/subscription/billing')}
              className={tabLinkClass}
            >
              Billing
            </Nav.Link>
          </Nav.Item>
        </HasRolePrivileges>
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.PROVISIONER]}
        >
          <Nav.Item>
            <Nav.Link href="/subscription/team" className={tabLinkClass}>Users</Nav.Link>
          </Nav.Item>
        </HasRolePrivileges>
        <HasRolePrivileges
          targetRoleList={[
            RaaRoles.ADMIN, RaaRoles.PROVISIONER, RaaRoles.MANAGER, RaaRoles.BILLING,
          ]}
        >
          <Nav.Item>
            {hasLapsedAccount ? (
              <Nav.Link className={tabLinkClass} {...disabledTabProps}>
                SMS Balance
              </Nav.Link>
            ) : (
              <Nav.Link
                href="/s/subscription/sms"
                eventKey="/s/subscription/sms"
                onClick={goTo('/s/subscription/sms')}
                className={tabLinkClass}
              >
                SMS Balance
              </Nav.Link>
            )}
          </Nav.Item>
        </HasRolePrivileges>
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.PROVISIONER]}
        >
          <Nav.Item>
            <Nav.Link
              href={hasLapsedAccount ? undefined : '/subscription/saml'}
              className={tabLinkClass}
              {...disabledTabProps}
            >
              SAML Login
            </Nav.Link>
          </Nav.Item>
        </HasRolePrivileges>
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN, RaaRoles.BILLING]}
        >
          <Nav.Item>
            <Nav.Link
              href={hasLapsedAccount ? undefined : '/subscription/faq'}
              className={tabLinkClass}
              {...disabledTabProps}
            >
              FAQ
            </Nav.Link>
          </Nav.Item>
        </HasRolePrivileges>
        <HasRolePrivileges
          targetRoleList={[RaaRoles.ADMIN]}
        >
          <Nav.Item>
            {hasLapsedAccount ? (
              <Nav.Link className={tabLinkClass} {...disabledTabProps}>
                Setup
                {' '}
                <ChecklistCompletionBadge />
              </Nav.Link>
            ) : (
              <Nav.Link
                href="/s/subscription/setup-checklist"
                eventKey="/s/subscription/setup-checklist"
                onClick={goTo('/s/subscription/setup-checklist')}
                className={tabLinkClass}
              >
                Setup
                {' '}
                <ChecklistCompletionBadge />
              </Nav.Link>
            )}
          </Nav.Item>
        </HasRolePrivileges>
      </Nav>
    </>
  );
}
SubscriptionNavTabs.propTypes = {
  activeKey: PropTypes.string.isRequired,
};
export default SubscriptionNavTabs;
